import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "coal",
  "use": "coal-usage",
  "viewBox": "0 0 15.4 15.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.4 15.4\" id=\"coal\"><style>#coal .st0{fill:none}#coal .st1{fill-rule:evenodd;clip-rule:evenodd}</style><title>节约标准煤</title><path id=\"coal_Clip-6\" class=\"st0\" d=\"M0 15.4h15.4V0H0z\" /><path id=\"coal_形状结合\" class=\"st1\" d=\"M7.7 1.1c.2 0 .4.1.5.3l6 11.8c.1.1.1.3.1.4 0 .3-.2.6-.6.7H9.2V7.1c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H4.4l2.8-5.4c.1-.2.3-.3.5-.3zm.6 11.6v1.6H1.1v-1.6h7.2zm0-2.5v1.6H1.1v-1.7l7.2.1zm0-2.5v1.6H1.1V7.7h7.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/coal.svg
// module id = y1M8
// module chunks = 6